export default __webpack_public_path__ + "static/media/white-down-arrow.8e85c924.svg";